var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsiamiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "121.000000pt",
    viewBox: "0 0 100.000000 121.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,121.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376 912 l-119 -289 -56 -11 c-193 -36 -258 -119 -137 -173 24 -10 58 -22 74 -25 l30 -6 -75 -182 c-41 -99 -79 -191 -84 -203 -8 -21 -6 -23 30 -23 l38 0 85 193 86 192 88 -5 c49 -3 123 -5 164 -5 41 0 115 2 163 5 l89 5 85 -193 85 -192 38 0 38 0 -75 182 c-41 101 -78 192 -83 204 -7 18 -3 22 38 33 59 16 109 46 117 72 16 48 -55 92 -192 119 l-61 12 -119 289 c-65 159 -120 289 -123 289 -3 0 -58 -130 -124 -288z m193 -114 c35 -79 65 -147 67 -153 3 -6 -46 -10 -136 -10 -90 0 -139 4 -136 10 39 97 131 295 136 295 3 0 35 -64 69 -142z m13 -194 l75 -7 30 -67 30 -68 -51 -6 c-66 -8 -266 -8 -332 0 l-52 7 30 68 31 68 51 4 c101 7 114 7 188 1z m-363 -74 c-21 -49 -24 -52 -53 -46 -16 4 -41 13 -54 22 -24 16 -24 16 -6 35 17 16 123 52 132 44 2 -2 -7 -26 -19 -55z m643 31 c13 -5 30 -16 37 -24 10 -13 8 -18 -11 -31 -13 -9 -38 -19 -55 -22 -29 -6 -33 -3 -46 28 -32 77 -32 77 11 67 22 -5 50 -13 64 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsiamiles);
export default __webpack_public_path__ + "static/media/asiamiles.c577c7d952859277182b1cb12c1fb361.svg";
export { ForwardRef as ReactComponent };